import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { VisibilityProvider } from './contexts/VisibilityContext';
import { ProtectedRoute, AdminRoute, SupervisorRoute, SecretariaAccessRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import AbastecimentosPage from './pages/AbastecimentosPage';
import VeiculosPage from './pages/VeiculosPage';
import FuncionariosPage from './pages/FuncionariosPage';
import PostosPage from './pages/PostosPage';
import CombustiveisPage from './pages/CombustiveisPage';
import SecretariasPage from './pages/SecretariasPage';
import RelatoriosPage from './pages/RelatoriosPage';
import FiltroIndividualPage from './pages/FiltroIndividualPage';
import GerarRequisicaoPage from './pages/GerarRequisicaoPage';
import MaquinasPage from './pages/MaquinasPage';
import ConfiguracoesPage from './pages/ConfiguracoesPage';
import UsuariosPage from './pages/UsuariosPage';
import ImportacaoPage from './pages/ImportacaoPage';
import AcessoTemporarioPage from './pages/AcessoTemporarioPage';
import FiscalLoginPage from './pages/FiscalLoginPage';
import FiscalDashboardPage from './pages/FiscalDashboardPage';
import './App.css';

// Componente que redireciona secretaria para /secretarias
const SmartDashboard = () => {
  const { isSecretaria } = useAuth();
  if (isSecretaria()) {
    return <Navigate to="/secretarias" replace />;
  }
  return <DashboardPage />;
};

// Componente para rota inicial inteligente
const SmartHome = () => {
  const { isSecretaria } = useAuth();
  if (isSecretaria()) {
    return <Navigate to="/secretarias" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <ThemeProvider>
      <VisibilityProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/acesso-temporario/:token" element={<AcessoTemporarioPage />} />
            <Route path="/fiscal-login" element={<FiscalLoginPage />} />
            <Route path="/fiscal" element={<FiscalDashboardPage />} />
            
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<SmartHome />} />
              <Route path="dashboard" element={<SmartDashboard />} />
              <Route path="abastecimentos" element={<AdminRoute><AbastecimentosPage /></AdminRoute>} />
              <Route path="importacao" element={<AdminRoute><ImportacaoPage /></AdminRoute>} />
              <Route path="veiculos" element={<SupervisorRoute><VeiculosPage /></SupervisorRoute>} />
              <Route path="funcionarios" element={<SupervisorRoute><FuncionariosPage /></SupervisorRoute>} />
              <Route path="postos" element={<SupervisorRoute><PostosPage /></SupervisorRoute>} />
              <Route path="combustiveis" element={<SupervisorRoute><CombustiveisPage /></SupervisorRoute>} />
              <Route path="secretarias" element={<SecretariaAccessRoute><SecretariasPage /></SecretariaAccessRoute>} />
              <Route path="relatorios" element={<SupervisorRoute><RelatoriosPage /></SupervisorRoute>} />
              <Route path="filtro-individual" element={<SupervisorRoute><FiltroIndividualPage /></SupervisorRoute>} />
              <Route path="gerar-requisicao" element={<SupervisorRoute><GerarRequisicaoPage /></SupervisorRoute>} />
              <Route path="maquinas" element={<SupervisorRoute><MaquinasPage /></SupervisorRoute>} />
              <Route path="configuracoes" element={<AdminRoute><ConfiguracoesPage /></AdminRoute>} />
              <Route path="usuarios" element={<AdminRoute><UsuariosPage /></AdminRoute>} />
            </Route>

            <Route path="*" element={<SmartHome />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
      </VisibilityProvider>
    </ThemeProvider>
  );
}

export default App;
